import { render, staticRenderFns } from "./groupdetial.vue?vue&type=template&id=12c2eb02&scoped=true&"
import script from "./groupdetial.vue?vue&type=script&lang=js&"
export * from "./groupdetial.vue?vue&type=script&lang=js&"
import style0 from "./groupdetial.vue?vue&type=style&index=0&id=12c2eb02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c2eb02",
  null
  
)

export default component.exports